import React from "react";

import OverviewContainer from "../../../../../container/overview";
import { ESupplyChainOverviewTabs } from "../../../../../models/supply.chain.overview.configure";

const ShipmentsOverviewPanel = () => {
  return <OverviewContainer panel={ESupplyChainOverviewTabs.SHIPMENTS} />;
};

export default ShipmentsOverviewPanel;
